export const dropZone = {
  'with-top-level-dropzone': {
    position: "relative",
    minHeight: "100%",
    maxHeight: "100%",
    transition: "0.15s ease height",
    overflow: "hidden",
    width: "100%",
    _before: {
      content: "' '",
      position: "absolute",
      border: "1px dashed",
      borderColor: "brand.500",
      borderRadius: "4px",
      top: "10px",
      bottom: "10px",
      right: 0,
      left: 0,
    }
  }
};
